import { render, staticRenderFns } from "./drawers.vue?vue&type=template&id=283ecd99&"
import script from "./drawers.vue?vue&type=script&lang=js&"
export * from "./drawers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports